/**
 * Supported Currencies for SubSift Toucan
 */
export const SUPPORTED_CURRENCIES = [
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'GBP', symbol: '£', name: 'British Pound' },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen' },
  { code: 'CAD', symbol: 'CA$', name: 'Canadian Dollar' },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee' },
  { code: 'BRL', symbol: 'R$', name: 'Brazilian Real' },
  { code: 'CNY', symbol: '元', name: 'Chinese Yuan' },
];

/**
 * Formats a value in the specified currency
 */
export const formatCurrency = (amount, currencyCode = 'USD') => {
  const currency = SUPPORTED_CURRENCIES.find(c => c.code === currencyCode) || SUPPORTED_CURRENCIES[0];
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.code,
  }).format(amount);
};

/**
 * Converts an amount from one currency to another using provided rates
 */
export const convertCurrency = (amount, fromCurrency, toCurrency, rates) => {
  if (!rates || fromCurrency === toCurrency) return amount;
  
  // All rates are relative to USD in our DB
  const amountInUSD = fromCurrency === 'USD' ? amount : amount / (rates[fromCurrency] || 1);
  const targetAmount = toCurrency === 'USD' ? amountInUSD : amountInUSD * (rates[toCurrency] || 1);
  
  return targetAmount;
};